import React from "react";
import { useTranslation } from "react-i18next";
import ClinicPrintFrame from "../../../../Components/GeneralComponents/ClinicPrintFrame.js";

const tableHeaderStyle = {
  borderBottom: "1px solid #cfd8dc",
  padding: "8px 6px",
  fontWeight: "bold",
  textAlign: "left",
  color: "#0b8eb0",
  fontSize: "3.1mm",
};

const tableCellStyle = {
  padding: "8px 6px",
  textAlign: "left",
  color: "#333",
  borderBottom: "1px solid #edf2f5",
  fontSize: "3mm",
};

const FreeMedicinePrint = ({ data }) => {
  const { t } = useTranslation();

  return (
    <ClinicPrintFrame
      compact
      doctorName={t("pharmacy.freeMedicine")}
      doctorTitle={`${t("pharmacy.order")}: #${data?.id || ""}`}
      date={data?.date}
      patientName={`${data?.patient_details?.firstname || ""} ${
        data?.patient_details?.lastname || ""
      }`.trim()}
      patientAge={data?.patient_details?.age}
      patientGender={data?.patient_details?.gender}
      leftNotes={["FREE", "MED", "ORDER"]}
      rxTitle={t("pharmacy.freeMedicine")}
      footerText={t("print.thankYou")}
    >
      <div
        style={{
          marginBottom: "10px",
          padding: "8px",
          backgroundColor: "#e8f8ef",
          border: "1px solid #26b36b",
          borderRadius: "4px",
          color: "#1f7f4f",
          fontWeight: "bold",
          fontSize: "3mm",
          textAlign: "center",
        }}
      >
        This medicine order is free of cost.
      </div>

      <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "8px" }}>
        <thead>
          <tr>
            <th style={tableHeaderStyle}>{t("pharmacy.medicine")}</th>
            <th style={tableHeaderStyle}>{t("pharmacy.pricePerQuantity")}</th>
            <th style={tableHeaderStyle}>{t("pharmacy.quantity")}</th>
            <th style={tableHeaderStyle}>{t("pharmacy.subtotal")}</th>
          </tr>
        </thead>
        <tbody>
          {(data?.items || []).map((item, idx) => (
            <tr key={idx}>
              <td style={tableCellStyle}>{item.stock_medicine_display}</td>
              <td style={{ ...tableCellStyle, textAlign: "center" }}>
                {item.sell_price_display}
              </td>
              <td style={{ ...tableCellStyle, textAlign: "center" }}>{item.quantity}</td>
              <td style={{ ...tableCellStyle, textAlign: "right" }}>
                {item.quantity * item.sell_price} AFN
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderTop: "1px solid #cfd8dc",
          paddingTop: "10px",
          marginTop: "10px",
          fontSize: "3.3mm",
          fontWeight: "bold",
          color: "#222",
        }}
      >
        <span>{t("print.totalAmount")}:</span>
        <span>{data?.total_price} AFN</span>
      </div>
    </ClinicPrintFrame>
  );
};

export default FreeMedicinePrint;
